/** Matches `AppStoreBasicInfoData` (`display_name` max:120, `description` max:500). */
export const STORE_DISPLAY_NAME_MAX_LENGTH = 120

export const STORE_DESCRIPTION_MAX_LENGTH = 500

/** Matches `AppData.name` (`max:40`) — internal app identifier, not the customer-facing name. */
export const STORE_APP_INTERNAL_NAME_MAX_LENGTH = 40

/** Matches `AppData` domain rule (`max:255` on full domain string). */
export const STORE_DOMAIN_MAX_LENGTH = 255

export const STORE_DOMAIN_REGEX = /^(([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}|localhost)(:[0-9]{1,5})?$/

/** Matches `AppStoreBasicInfoData.slug` (`max:100`). */
export const STORE_SLUG_MAX_LENGTH = 100

/** Same rule the backend applies to `AppData.slug`. */
export const STORE_SLUG_REGEX = /^[a-z0-9]+(-[a-z0-9]+)*$/
